import { Default, Detail,  List, Create } from "./views";
const Module = {
    name: "audiencelead",
    defaultRoutePath: "/audiences/audiencelead",
    menuItemScope: "audience",
    menuItemName: "audienceLeads",

    routes: [
        {
            path: "/audiences/audiencelead",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
